import { onboardingFlow } from '../scripts/userflows/onboardingFlow';

/**
 * Flow Registry
 *
 * Central registry that discovers and provides access to all available flows.
 * Add new flows here as the application grows.
 */

export interface FlowModule {
  id: string;
  name: string;
  description: string;
  definition: any; // Flow definition with flows, forms, prompts
}

class FlowRegistry {
  private flows: Map<string, FlowModule> = new Map();

  constructor() {
    this.registerFlow(onboardingFlow);
    // Add more flows here as features grow:
    // this.registerFlow(esgQuestionnaireFlow);
    // this.registerFlow(surveyFlow);
  }

  /**
   * Register a flow module
   */
  registerFlow(flowModule: any) {
    if (!flowModule.id || !flowModule.definition) {
      throw new Error('Flow module must have id and definition');
    }

    this.flows.set(flowModule.id, {
      id: flowModule.id,
      name: flowModule.name,
      description: flowModule.description,
      definition: flowModule.definition,
    });

    console.log(`[FlowRegistry] Registered flow: ${flowModule.id}`);
  }

  /**
   * Get a flow by ID
   */
  getFlow(flowId: string): FlowModule | null {
    return this.flows.get(flowId) || null;
  }

  /**
   * Get all registered flows
   */
  getAllFlows(): FlowModule[] {
    return Array.from(this.flows.values());
  }

  /**
   * Check if a flow is registered
   */
  hasFlow(flowId: string): boolean {
    return this.flows.has(flowId);
  }
}

export const flowRegistry = new FlowRegistry();
